export type ResponseBase<T> = {
  error: null | string
  errorEx: null | unknown
  result: T
}

export type RuleType =
  | 'arrival-date'
  | 'preemption-code-validation'
  | 'tax-code-validation'
  | 'max-reservations-per-code'

export type SectorRuleResponse = ResponseBase<{
  sectorRules: {
    id: number
    operator: string
    ruleParameter: null | string
    ruleType: RuleType
    validationField: string
    sectorOldId: number
  }[]
}>

export type ShouldValidateFormResponse = ResponseBase<{
  shouldValidate: boolean
}>

export type UnavailableSectorsResponse = ResponseBase<{
  unavailableSectors: {
    sectorId: number
    sectorOldId: number
    errors: string[]
  }[]
}>

export enum SectorRuleError {
  INVALID_CODE = 'invalid-code',
  TOO_MANY_RESERVATIONS = 'too-many-reservations',
  INVALID_END_DATE = 'invalid-end-date',
}
